import { Encrypted } from '../Constants/configuration';

export class DatosCotizacion {
    /**Datos para multicotiza */
    multicotiza: DatosMulticotiza = new DatosMulticotiza();
    /**Datos extras de auto */
    datosAuto: DatosAuto = new DatosAuto();
}

export class DatosMulticotiza {
    /**Negocio */
    f1: number;
    /**Aseguradora */
    f2: number;
    /**Clave amis */
    f3: string;
    /**Modelo de auto */
    f4: number;
    /**Tipo mkp */
    f5: number;
    /**Es pickup */
    f7: number;
    /**Marca */
    f8?: string;
    /**Tipo vehiculo */
    f9?: string;
}

export class DatosAuto {
    /**Paquete */
    paquete: number = 0;
    /**Logo marca */
    logoMarca: string;
    /**Descripcion Vehiculo */
    descripcion?: string = "";
    /**Marca */
    marca?:string = "";
    tipoUnidad?: number = 0;
    /**Es para indicar si es valor comercial(1), valor factura(2) */
    coberturaSobre?:number = 1;
    /**Cantidad para valor factura */
    valorFactura?:string = '' ;
}

export class CotizacionCompartir {
    /** */
    cot: string = new Encrypted().ZERO;
    cots: Array<Cot> = [];
}

export class Cot {
    cot: number;
}

export class CotizacionComparte{
    paquete:string = 'AMPLIA';
    formpag:string = 'Contado';
    vehiculo:string = '';
    correo:string = '';
    modelo:number = 0;
}